/**
 * Resolves an image source that may be a URL, a raw base64 string, or a data URI.
 * Returns a valid src for <img> or null if no image is available.
 */
export const resolveImageSrc = (image: string | undefined | null): string | null => {
  if (!image) return null;
  if (image.startsWith('data:')) return image;
  if (image.startsWith('http') || image.startsWith('/')) return image;
  if (image.length > 0) return `data:image/png;base64,${image}`;
  return null;
};

/**
 * Validates that an image file has the exact specified dimensions.
 * Resolves with `true` when the image matches, `false` otherwise.
 */
export const validateImageDimensions = (
  file: File,
  requiredWidth: number,
  requiredHeight: number,
): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      resolve(img.naturalWidth >= requiredWidth && img.naturalHeight >= requiredHeight);
    };
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      resolve(false);
    };
    img.src = URL.createObjectURL(file);
  });
};
